export const CLIENT_MCP_TOOLS_PRODUCT_KEY = "ConvokeClientMcpTools";
export const CLIENT_MCP_TOOLS_RESOURCE_KEY = "ClientMcpToolsEndpoint";
export const CLIENT_MCP_TOOLS_SETUP_PATH_KEY = "ClientMcpToolsSetup";
export const CLIENT_MCP_SERVER_PRODUCT_KEY = "ConvokeClientMcpServer";
export const CLIENT_MCP_SERVER_RESOURCE_KEY = "ClientMcpServer";
export const CLIENT_MCP_SERVER_SETUP_PATH_KEY = "ClientMcpServerSetup";
export const LEGACY_CLIENT_MCP_TOOLS_RESOURCE_KEY = "MCPToolEndpoint";
export const PRIVILEGED_MCP_TOOLS_PRODUCT_KEY = "ConvokeMcpTools";
export const ADMIN_MCP_TOOLS_RESOURCE_KEY = "ConvokeAdminMcpTools";
export const DEV_SYSADMIN_MCP_TOOLS_RESOURCE_KEY = "ConvokeDevSysAdminMcpTools";
export const PRIVILEGED_MCP_TOOLS_SETUP_PATH_KEY = "PrivilegedMcpToolsSetup";

export const MCP_TOOLS_OVERVIEW_SCREEN_KEY = "mcp-tools-overview";
export const MCP_TOOLS_AUTH_SCREEN_KEY = "mcp-tools-authentication";
export const MCP_TOOLS_ACTIVE_SESSIONS_SCREEN_KEY = "mcp-tools-active-sessions";
export const MCP_TOOLS_ACCESS_SCREEN_KEY = "mcp-tools-access";
export const MCP_TOOLS_CAPABILITIES_SCREEN_KEY = "mcp-tools-capabilities";
export const MCP_TOOLS_RULES_SCREEN_KEY = "mcp-tools-rules";
export const MCP_TOOLS_EXPOSURE_SCREEN_KEY = "mcp-tools-exposure";

const normalize = (value) => String(value ?? "").trim().toLowerCase();

const readValue = (item, ...keys) => {
  for (const key of keys) {
    const value = item?.[key];
    if (value !== undefined && value !== null) return value;
  }
  return undefined;
};

const readCustomField = (item, ...keys) => {
  const customFields = readValue(item, "CustomFields", "customFields") || {};
  return readValue(customFields, ...keys, ...keys.map((key) => `${key.charAt(0).toLowerCase()}${key.slice(1)}`));
};

const isClientMcpToolsMarker = (item) => {
  const productKey = normalize(readValue(item, "ProductKey", "productKey"));
  const resourceKey = normalize(readValue(item, "ProductResourceKey", "productResourceKey", "Key", "key"));
  const setupPathKey = normalize(readValue(item, "SetupPathKey", "setupPathKey"));
  const routeMode = normalize(readCustomField(item, "McpToolsRouteMode"));
  const customSetupPathKey = normalize(readCustomField(item, "McpToolsSetupPathKey", "SetupPathKey"));
  return productKey === normalize(CLIENT_MCP_TOOLS_PRODUCT_KEY)
    || productKey === normalize(PRIVILEGED_MCP_TOOLS_PRODUCT_KEY)
    || resourceKey === normalize(CLIENT_MCP_TOOLS_RESOURCE_KEY)
    || resourceKey === normalize(LEGACY_CLIENT_MCP_TOOLS_RESOURCE_KEY)
    || resourceKey === normalize(ADMIN_MCP_TOOLS_RESOURCE_KEY)
    || resourceKey === normalize(DEV_SYSADMIN_MCP_TOOLS_RESOURCE_KEY)
    || setupPathKey === normalize(CLIENT_MCP_TOOLS_SETUP_PATH_KEY)
    || setupPathKey === normalize(PRIVILEGED_MCP_TOOLS_SETUP_PATH_KEY)
    || customSetupPathKey === normalize(CLIENT_MCP_TOOLS_SETUP_PATH_KEY)
    || customSetupPathKey === normalize(PRIVILEGED_MCP_TOOLS_SETUP_PATH_KEY)
    || routeMode === "client"
    || routeMode === "admin"
    || routeMode === "sysadmin";
};

const isClientMcpServerMarker = (item) => {
  const productKey = normalize(readValue(item, "ProductKey", "productKey"));
  const resourceKey = normalize(readValue(item, "ProductResourceKey", "productResourceKey", "Key", "key"));
  const setupPathKey = normalize(readValue(item, "SetupPathKey", "setupPathKey"));
  return productKey === normalize(CLIENT_MCP_SERVER_PRODUCT_KEY)
    || resourceKey === normalize(CLIENT_MCP_SERVER_RESOURCE_KEY)
    || setupPathKey === normalize(CLIENT_MCP_SERVER_SETUP_PATH_KEY);
};

export const isClientMcpToolsResource = (...sources) =>
  sources
    .flat()
    .filter(Boolean)
    .some((source) =>
      isClientMcpToolsMarker(source)
      || isClientMcpToolsMarker(readValue(source, "ProductResource", "productResource"))
      || isClientMcpToolsMarker(readValue(source, "ClientResource", "clientResource"))
      || isClientMcpToolsMarker(readValue(source, "ResourceConfiguration", "resourceConfiguration")));

export const isClientMcpServerResource = (...sources) =>
  sources
    .flat()
    .filter(Boolean)
    .some((source) =>
      isClientMcpServerMarker(source)
      || isClientMcpServerMarker(readValue(source, "ProductResource", "productResource"))
      || isClientMcpServerMarker(readValue(source, "ClientResource", "clientResource"))
      || isClientMcpServerMarker(readValue(source, "ResourceConfiguration", "resourceConfiguration")));

export const isClientMcpExperienceResource = (...sources) =>
  isClientMcpServerResource(...sources) || isClientMcpToolsResource(...sources);

export const isClientMcpToolsWizard = (wizard) => {
  if (!wizard) return false;
  return isClientMcpToolsResource(
    wizard,
    readValue(wizard, "ProductResource", "productResource"),
    readValue(wizard, "ClientResource", "clientResource"),
    readValue(wizard, "ResourceConfiguration", "resourceConfiguration")
  );
};

export const CLIENT_MCP_TOOLS_NAVIGATIONS = [
  { key: MCP_TOOLS_OVERVIEW_SCREEN_KEY, displayName: "Overview", icon: "network", sequence: 10 },
  { key: MCP_TOOLS_RULES_SCREEN_KEY, displayName: "Rules", icon: "shield", sequence: 20 },
  { key: MCP_TOOLS_EXPOSURE_SCREEN_KEY, displayName: "Exposed Items", icon: "list", sequence: 30 }
];

export const CLIENT_MCP_SERVER_NAVIGATIONS = [
  { key: MCP_TOOLS_OVERVIEW_SCREEN_KEY, displayName: "Overview", icon: "network", sequence: 10 },
  { key: MCP_TOOLS_AUTH_SCREEN_KEY, displayName: "Authentication", icon: "key", sequence: 20 },
  { key: MCP_TOOLS_ACTIVE_SESSIONS_SCREEN_KEY, displayName: "Active Sessions", icon: "shield", sequence: 30 }
];
